import { cva, type VariantProps } from 'class-variance-authority';

export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap',
    'font-sans font-medium tracking-tightish',
    'border rounded-sm',
    'transition-[background-color,border-color,color,transform] duration-150',
    'disabled:pointer-events-none disabled:opacity-50',
    'active:translate-y-px',
  ].join(' '),
  {
    variants: {
      variant: {
        primary:
          'bg-icaria-600 border-icaria-600 text-paper hover:bg-icaria-700 hover:border-icaria-700',
        default:
          'bg-foreground border-foreground text-background hover:bg-icaria-600 hover:border-icaria-600',
        ghost:
          'bg-transparent border-line-strong text-foreground hover:bg-card hover:border-foreground',
        outline:
          'bg-card border-line text-ink-2 hover:border-foreground hover:text-foreground',
        destructive:
          'bg-card border-destructive text-destructive hover:bg-destructive hover:text-destructive-foreground',
        link:
          'border-transparent bg-transparent text-icaria-600 hover:text-icaria-700 underline-offset-4 hover:underline px-0',
        // ── Aliases preservados del repo previo ──
        success:
          'bg-success border-success text-success-foreground hover:bg-success/90 hover:border-success/90',
        secondary:
          'bg-secondary border-secondary text-secondary-foreground hover:bg-secondary/80',
        warning:
          'bg-warning border-warning text-warning-foreground hover:bg-warning/90',
      },
      size: {
        sm: 'h-8 px-3 text-sm',
        md: 'h-9 px-4 text-base',
        default: 'h-9 px-4 text-base',
        lg: 'h-11 px-5 text-base',
        xl: 'h-14 px-10 text-base rounded-lg',
        huge: 'h-32 px-10 text-2xl font-bold rounded-lg',
        icon: 'h-9 w-9 p-0',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
